<template lang="pug">
router-view
</template>

<script>
import  router from './../../router'

export default {
  data () {
    return {}
  },
  computed: {},
  ready () {},
  watch: {},
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// user-page.vue?002a7fde